<template>
  <div>
      <a-list item-layout="horizontal" :split="false" :data-source="resultInfoArr" :class="containerStyle">
        <a-list-item slot="renderItem" slot-scope="item" :class="item.id === 'expiredTs' ? expiredColor : ''">
          <a-list-item-meta>
            <span slot="title" class="title_font_Weight">
              {{ item.label }}
              <a-popover v-if="item.id === 'enabledCode'"
                        trigger="click"
                        placement="topLeft"
                        overlayClassName="popover_container">
                <template slot="content">
                  <span>納管碼為裝載至車輛上之聯網裝置開通後，產生一可供車隊納管之一串數字。</span>
                </template>
                <a href="#" @click.prevent>
                  <a-icon type="question-circle" class="text-green"/>
                  說明
                </a>
              </a-popover>
            </span>
            <span slot="description" class="description_font_Weight">
              {{item.value}}
              <p v-if="item.value === 'STMB-4000'" :style="{ fontSize: '14px'}">說明：此裝置將會有部分欄位、功能、資料無法提供。</p>
            </span>
          </a-list-item-meta>
          <template v-if="item.id === 'enabledCode'">
            <a-button v-if="resendSMSCountDown === 60" class="send_code_btn" @click="handleSendEnabledCode">
              <a-icon type="mail" :style="{ fontSize: '16px' }" />
              寄送至手機
            </a-button>
            <a-button v-else class="send_code_btn disabled">
              <a-icon type="clock-circle" :style="{ fontSize: '16px' }" />
              {{resendSMSCountDown}}秒後重新發送
            </a-button>
          </template>
        </a-list-item>
      </a-list>
      <div class="service-status" v-if="serviceStatus">
        <p>基本服務已啟用</p>
      </div>
      <div class="service-status disabled" v-else>
        <p>基本服務已逾期</p>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { sendEnabledCodeApi } from '../../api/api';

  export default {
      name: 'ProvisioningResult',
      data() {
        return {
          resultInfoArr: new Array(4), // 根據顯示資訊設定陣列長度
          currentPath: '/',
          visible: false,
          resultData: {},
          msgObj: {
              visible: false,
              title: '發送錯誤',
              okText: '確認',
              cancelText: '',
              detailText: '',
              msgClass: 'msg_confirm_modal',
          },
          timer: null,
          resendSMSCountDown: 60,
          expiredColor: '',
          userAgent: navigator.platform, // 使用的系統
          serviceStatus: true,
        }
      },
      mounted () {
          this.currentPath = this.$route.path;
      },
      methods: {
        // label
        getLabelStr(label) {
          let str = '';

          switch (label) {
            case 'carNo':
              str = '車號';
              break;
            case 'enabledCode':
              str = '納管碼';
              break;
            case 'expiredTs':
              str = '服務到期日';
              break;
            case 'openTs':
              str = '服務開通日';
              break;
            case 'openedMobile':
              str = '手機號碼';
              break;
            case 'openedUser':
              str = '姓名';
              break;
            // case 'productName':
            //   str = '裝置類型';
            //   break;
            default:
              break;
          }

          return str;
        },
        // 項目內容
        handleItemFormat(itemKey, itemValue) {
          let formatValue = '';

          switch (itemKey) {
            case 'openTs':
              formatValue = this.formatOpenTs;
              break;
            case 'expiredTs':
              formatValue = this.formatExpiredTs;
              break;
            case 'enabledCode':
              formatValue = this.formatEnabledCode;
              break;
            case 'openedMobile':
              formatValue = this.formatOpenedMobile;
              break;
            case 'productName':
              formatValue = this.formatProductName;
              break;
            default:
              formatValue = itemValue;
              break;
          }

          return formatValue;
        },
        putResultItemPosition(itemKey, itemData) {
          switch (itemKey) {
            case 'openedUser':
              this.resultInfoArr.splice(0, 1, itemData);
              break;
            case 'carNo':
              this.resultInfoArr.splice(1, 1, itemData);
              break;
            case 'openedMobile':
              this.resultInfoArr.splice(2, 1, itemData);
              break;
            case 'enabledCode':
              this.resultInfoArr.splice(3, 1, itemData);
              break;
            // case 'openTs':
            //   this.resultInfoArr.splice(4, 1, itemData);
            //   break;
            // case 'expiredTs':
            //   this.resultInfoArr.splice(5, 1, itemData);
            //   break;
            // case 'productName':
            //   this.resultInfoArr.splice(6, 1, itemData);
            //   break;
            default:
              break;
          }
        },
        getResultInfoArr(result) {
          // 將開通結果資訊裡不是"納管狀態"、"車隊代碼"、"開通狀態"、"服務到期日"、"服務開通日"、"productName"的資料放到resultInfoArr陣列，調整先後順序並存放
          for (const [key, value] of Object.entries(result)) {
            const unShowFields = ['enabledStatus','fleetCode','opened','expiredTs','openTs','productName'];
            if (!unShowFields.includes(key) ) {
              const itemObj = {
                id: key,
                key,
                label: this.getLabelStr(key),
                value: this.handleItemFormat(key, value),
              };
              this.putResultItemPosition(key, itemObj);
            }else if(key === 'expiredTs') { // 確認服務期限狀態
              // console.log('expiredTs',this.$moment(value).isAfter(new Date()));
              this.serviceStatus = this.$moment(value).isAfter(new Date());
            }
          }
        },
        handleSendEnabledCode() {
          // 寄送後開始倒數60s
          this.timer = setInterval(() => {
            this.resendSMSCountDown --; //倒數
            if(this.resendSMSCountDown === 0) {
              clearInterval(this.timer);
              this.resendSMSCountDown = 60;
            }
          },1000) //每秒倒數
          const params = {
            encodedImei: this.deviceUid,
          };
          this.sendSmsToPhone(params);

        },
        async sendSmsToPhone(params) {
            try {
                const result = await sendEnabledCodeApi(params);

                this.getResponseMSg(result.status);
                this.$emit('responseStatus', this.msgObj);

            } catch (error) {
                console.log(error);
            }
        },
        getResponseMSg(status) {
          const resultPhone = this.formatOpenedMobile;

          switch (status) {
            case 0:
                this.msgObj = {
                    ...this.msgObj,
                    title: '寄送成功',
                    detailText: `納管碼已發送至${resultPhone}`,
                    visible: true,
                    msgClass: 'msg_confirm_modal'
                };
                break;
              // 3:設備不存在、4:設備停用
              case 3:
              case 4:
                  this.msgObj = {
                      ...this.msgObj,
                      visible: true,
                      title: '裝置不存在',
                      okText: '撥打電話',
                      cancelText: '否',
                      detailText: '查無此裝置資訊，請聯繫客服人員',
                      msgClass: 'msg_error_modal',
                  };
                  break;
              case 5:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '設備未開通',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 6:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '設備過期',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 7:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '設備已損壞',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 8:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '簡訊發送失敗',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 9:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '簡訊超過額度',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 10:
                  this.msgObj = {
                      ...this.msgObj,
                      title: '發送錯誤',
                      detailText: '簡訊發送太頻繁',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              default:
                  break;
          }
        },
      },
      computed: {
          ...mapState('identidyOpenResult', ['openResult']),
          ...mapState('identidyOpenStatus', ['openStatus']),
          ...mapState('identidyOpenStatus', ['deviceUid']),
          ...mapGetters('identidyOpenResult', ['formatOpenTs', 'formatExpiredTs', 'formatEnabledCode', 'formatOpenedMobile','formatProductName']),
          containerStyle() {
              return this.currentPath === '/individual/deviceInfo' ? 'individual_result_container' : '';
          },
      },
      watch: {
        openResult: {
          handler() {
            this.getResultInfoArr(this.openResult);
            this.expiredColor = this.openResult.opened === 2 ?  'expiredColor' : '';
          },
          deep: true,
          immediate: true,
        }
      }
  }
</script>

<style lang="scss" scoped>
  .ant-list-item {
    padding: 0px 0 12px 0;
    align-items: flex-end;
    .ant-list-item-meta-title {
      line-height: 24px;
      color: #343741;
      a {
        color: #638D0A;
        margin-left: 14px;
        font-weight: 400;
      }
    }
    .ant-list-item-meta-description {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      color: #000000;
    }
  }

  .expiredColor {
    .ant-list-item-meta-description {
      color: #FF6565;
    }
  }

  .send_code_btn {
    background-color: #C0E560;
    padding: 7px 12px;
    border-radius: 8px;
    box-shadow: none;
    border: none;
    color: #1E475D;
  }

  .send_code_btn.disabled{
    background-color: #E5E5E5;
    color: #00000040;
  }

  .individual_result_container {
    padding: 0 13px;
  }

</style>
